module.exports = __webpack_public_path__ + "static/media/board-game.84a786e5.jpg";